import { NewOAuthEmailIntegration } from './NewOAuthEmailIntegration';

export const NewExchangeEmailIntegration = ({ onClose }) => {
  return (
    <NewOAuthEmailIntegration
      onClose={onClose}
      provider="Microsoft"
      apiEndpoint="exchange/auth-url"
    />
  );
};
